import React from 'react';
import { NavLink, Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import clsx from 'clsx';

import { NavbarTitle } from '../../../shared/components/navbar-title';
import { useScreenSize } from '../../../shared/hooks/use-screen-size';
import { useAppDispatch, useAppSelector } from '../../../store';
import { getIsRestaurant, openAccountMenu, openMainMenu } from '../../../store/user';
import { MainNavBar } from '../../AppDrawer/MainNavBar';
import { TopNavBar } from '../../AppDrawer/MainNavBar/top-nav-bar';
import { AccountMenu } from '../account-menu';
import { PaymentMethods } from './PaymentMethods';
import { AddPaymentMethod } from './PaymentMethods/add-payment-method';
import { Subscriptions } from './Subscriptions';

import { useStyles } from './style';
import { CurrentPlan } from './CurrentPlan';

export const Billing: React.FC = () => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISABLE_KEY as string, { apiVersion: '2023-08-16' });

  const { isMobile, isTablet } = useScreenSize();
  const dispatch = useAppDispatch();
  const isRestaurant = useAppSelector(getIsRestaurant);
  const isSupplier = !isRestaurant; 

  const openMenus = () => {
    dispatch(openMainMenu());
    dispatch(openAccountMenu());
  };

  const isAddPaymentPage = pathname.includes('/account/billing/payment/add');

  return (
    <Elements stripe={stripePromise}>
      <TopNavBar
        withTopNavigation={!isAddPaymentPage}
        isAccount={true}
        leftComponent={
          <div>
            <NavbarTitle title='Billing' showBackBtn={true} backHandler={openMenus} classNames={classes.topNavBarTitle} />
            <div className={classes.headerNavBox}>
              <NavLink to='/account/billing/subscriptions' className={classes.headerLink} activeClassName={classes.headerLinkActive}>
                Subscriptions
              </NavLink>
              <NavLink
                to='/account/billing/transactions'
                className={clsx(classes.headerLink, classes.tabLinkDisabled)}
                activeClassName={classes.headerLinkActive}
                exact={true}
              >
                Transactions
              </NavLink>
              <NavLink to='/account/billing/payment' className={classes.headerLink} activeClassName={classes.headerLinkActive}>
                Payment Methods
              </NavLink>
            </div>
          </div>
        }
        bottomComponent={
          isMobile ? (
            isRestaurant ? (
              <div>
                <div className={classes.titleWrap}>
                  <NavbarTitle
                    title={isAddPaymentPage ? 'Add payment method' : 'Billing'}
                    showBackBtn={true}
                    backHandler={isAddPaymentPage ? undefined : openMenus}
                    classNames={classes.topNavBarTitle}
                  />
                  {pathname.includes('default') && <span className={classes.defaultBadge}>Default</span>}
                </div>
                {!isAddPaymentPage && (
                  <div className={classes.headerNavBox}>
                    <NavLink to='/account/billing/subscriptions' className={classes.headerLink} activeClassName={classes.headerLinkActive}>
                      Subscriptions
                    </NavLink>
                    <NavLink
                      to='/account/billing/transactions'
                      className={classes.headerLink}
                      activeClassName={classes.headerLinkActive}
                      exact={true}
                    >
                      Transactions
                    </NavLink>
                    <NavLink to='/account/billing/payment' className={classes.headerLink} activeClassName={classes.headerLinkActive}>
                      Payment Methods
                    </NavLink>
                  </div>
                )}
              </div>
            ) : undefined
          ) : undefined
        }
      />
      <MainNavBar isAccount={true} />
      <div className={clsx(classes.accountContainer, isRestaurant && classes.accountContainerCustomer, isSupplier && classes.supplierContainer)}>
        <div className={clsx(classes.accountHeader)}>
          <div className={classes.accountTitle}>My Account</div>
        </div>
        <div className={classes.accountBody}>
          <AccountMenu showBack={!isRestaurant} />
          <div className={classes.accountContent}>
            {isRestaurant && isTablet && (
              <div className={classes.tabletTitleCustomer}>
                <NavbarTitle
                  title={isAddPaymentPage ? 'Add payment method' : 'Billing'}
                  showBackBtn={true}
                  backHandler={isAddPaymentPage ? undefined : openMenus}
                />
              </div>
            )}
            {isRestaurant &&  <>
              <div className={classes.titleBox}>
                <div className={classes.title}>Billing</div>
              </div>
              <div className={clsx(classes.tabs, isRestaurant && classes.tabsCustomer)}>
                <NavLink to='/account/billing/subscriptions' className={classes.tabLink} activeClassName={classes.tabLinkActive}>
                  Subscriptions
                </NavLink>
                <NavLink to='/account/billing/payment' className={classes.tabLink} activeClassName={classes.tabLinkActive}>
                  Payment Methods
                </NavLink>
                <NavLink
                  to='/account/billing/transactions'
                  className={clsx(classes.tabLink, classes.tabLinkDisabled)}
                  activeClassName={classes.tabLinkActive}
                  exact={true}
                >
                  Transactions
                </NavLink>
              </div>
            </>}
            <Switch>
              <Route path='/account/billing/payment/add'>
                <AddPaymentMethod />
              </Route>
              {/*<Route path='/account/billing/transactions'>*/}
              {/*  <Transactions />*/}
              {/*</Route>*/}
              {isRestaurant && <Route path='/account/billing/payment'>
                <PaymentMethods />
              </Route>}
              {isRestaurant && <Route path='/account/billing/subscriptions' component={Subscriptions} />}
              {isSupplier && <Route path='/account/billing/plans' component={CurrentPlan} />}
              <Route path='/account/billing'>
                {isRestaurant
                  ? <Redirect to='/account/billing/subscriptions' />
                  : <Redirect to='/account/billing/plans' />
                }
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </Elements>
  );
};
